import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'abstract' },
  { name: 'assessment' },
  { name: 'audience' },
  { name: 'author' },
  { name: 'descriptor' },
  { name: 'educationlevel' },
  { name: 'law' },
  { name: 'location' },
  { name: 'pubyear' },
  { name: 'source' },
  { name: 'title' },
  { name: 'funded' },
  { name: 'wwcr' }
]

const defaultSyntaxGuideUrl = 'https://eric.ed.gov/?advanced'

class EricEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('ERIC')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.fieldSpecifiers.forEach(x => this.fieldSpecifiers.push(`+${x}`))
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  mapOperator (operator) {
    switch (operator.toUpperCase()) {
      case 'AND': return { op: '', spaces: true }
      case 'OR': return { op: 'OR', spaces: true }
      case 'NOT': return { op: '-', spaces: false }
    }
    return { op: operator, spaces: true }
  }
  formulateQuery (query) {
    return 'https://eric.ed.gov/?q=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default EricEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/EricEngine.js